// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Item_attributes_SalvarOpcaoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/item_attributes/salvar_opcao
 *
 * Returns the id of the inserted/updated item-attribute option.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Item_attributes_SalvarOpcaoResponseDados {
so_item_attribute_option_id: number
}

export type Item_attributes_SalvarOpcaoResponse = ApiResponse<Item_attributes_SalvarOpcaoResponseDados>;

registerResponseContract('Item_attributes_SalvarOpcaoResponse', {
  so_item_attribute_option_id: { type: 'number',  required: true },
})
